import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
export function createStore({ rootReducer, middleware = [], includeLoggerInDevelopment = false, }) {
    const logger = createLogger();
    const extendedMiddleware = [...middleware];
    if (includeLoggerInDevelopment && process.env.NODE_ENV === "development") {
        extendedMiddleware.push(logger);
    }
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(extendedMiddleware),
    });
    return store;
}
//# sourceMappingURL=createStore.js.map